import React, { useEffect } from "react";
import { styled } from "@mui/system";
import SideBar from "./SideBar/SideBar";
import FriendsSidebar from "./FriendsSidebar/FriendsSidebar";
import ChannelsSidebar from "./ChannelsSidebar/ChannelsSidebar";
import Messenger from "./Messenger/Messenger";
import AppBar from "./AppBar.js/AppBar";
import ServerMembersPanel from "./ServerMembersPanel";
import VoiceCallDialog from "./Messenger/VoiceCallDialog";
import { logout } from "../shared/utils/auth";
import { connect } from "react-redux";
import { getActions } from "../store/actions/authActions";
import { connectWithSocketServer } from "../realtimeCommunication/socketConnection";
import * as api from "../api";
import { setServerInvitations, setServers } from "../store/actions/roomActions";

const Wrapper = styled("div")({
  width: "100%",
  height: "100vh",
  display: "flex",
});

const Dashboard = ({ setUserDetails, setServers, selectedServer }) => {
  useEffect(() => {
    const userDetails = localStorage.getItem("user");
    if (!userDetails) {
      logout();
    } else {
      setUserDetails(JSON.parse(userDetails));
      console.log("SocketConnection Rerender Check");
      connectWithSocketServer(JSON.parse(userDetails));
      api.getServers().then((response) => {
        if (!response.error) {
          setServers(response.data.servers);
        }
      });
      api.getServerInvitations().then((response) => {
        if (!response.error) {
          setServerInvitations(response.data.invitations);
        }
      });
    }
  }, []);
  return (
    <Wrapper>
      <SideBar />
      {selectedServer ? <ChannelsSidebar /> : <FriendsSidebar />}
      <Messenger />
      {selectedServer && <ServerMembersPanel />}
      <AppBar />
      <VoiceCallDialog />
    </Wrapper>
  );
};

const mapActionsToProps = (dispatch) => {
  return {
    ...getActions(dispatch),
    setServers: (servers) => dispatch(setServers(servers)),
    setServerInvitations: (invitations) => dispatch(setServerInvitations(invitations)),
  };
};

const mapStoreStateToProps = ({ room }) => ({
  selectedServer: room.selectedServer,
});

export default connect(mapStoreStateToProps, mapActionsToProps)(Dashboard);
